import { render, staticRenderFns } from "./ModalVisualizarRecursoContrarrazao.vue?vue&type=template&id=5dfa625d"
import script from "./ModalVisualizarRecursoContrarrazao.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarRecursoContrarrazao.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarRecursoContrarrazao.vue?vue&type=style&index=0&id=5dfa625d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports